// ユーザー棚卸しの純関数ロジック。従業員名簿CSV(SmartHR/カオナビ)と SF ユーザーをメールで突合し、
// 「名簿に無い SF アクティブユーザー = 退職者アカウント残存の疑い」を検出する(設計 2026-06-10)。
import { parseCsv, detectColumns } from "../ui/csv";
import type { SfUser } from "./audit-data";

export interface RosterRow {
  readonly email: string;
  readonly name: string;
  readonly status: string;
}

export interface RosterParseResult {
  readonly rows: readonly RosterRow[];
  readonly error?: string;
}

export function rosterFromCsv(text: string): RosterParseResult {
  const parsed = parseCsv(text);
  if (parsed.length < 2) {
    return { rows: [], error: "CSV にデータ行がありません。ヘッダ行 + 1行以上が必要です。" };
  }
  const header = parsed[0]!;
  const cols = detectColumns(header);
  if (cols.email < 0) {
    return { rows: [], error: "メールアドレス列が見つかりません（ヘッダに「メール」「mail」等の列が必要です）。" };
  }
  const rows = parsed
    .slice(1)
    .map((r) => ({
      email: (r[cols.email] ?? "").trim(),
      name: cols.name >= 0 ? (r[cols.name] ?? "").trim() : "",
      status: cols.status >= 0 ? (r[cols.status] ?? "").trim() : "",
    }))
    .filter((r) => r.email !== "");
  return { rows };
}

export interface ReconcileResult {
  readonly residual: readonly SfUser[]; // 名簿に無い SF アクティブユーザー(主検出)
  readonly notInSf: readonly RosterRow[]; // 名簿に居るが SF に無い(参考)
  readonly matchedCount: number;
}

const norm = (email: string): string => email.trim().toLowerCase();

export function reconcileUsers(roster: readonly RosterRow[], sfUsers: readonly SfUser[]): ReconcileResult {
  const rosterEmails = new Set(roster.map((r) => norm(r.email)));
  const activeUsers = sfUsers.filter((u) => u.active); // 既に無効化済みは対象外
  const residual = activeUsers.filter((u) => !rosterEmails.has(norm(u.email)));
  const sfEmails = new Set(sfUsers.map((u) => norm(u.email)));
  const notInSf = roster.filter((r) => !sfEmails.has(norm(r.email)));
  return { residual, notInSf, matchedCount: activeUsers.length - residual.length };
}
